<template lang="pug">
  .Paragraph.Paragraph-margin.ParagraphExergue

    div(v-html="item.get('attributes.content.value')")

</template>

<script>
import scrollUpdate from '@/mixins/scrollUpdate'

export default {
  props: ['item'],
  mixins: [scrollUpdate],
  data () {
    return {}
  },
  methods: {
    onProgress (p, pv) {
      this.percent = Math.round(p * 100) / 100
      this.percentV = Math.round(pv * 100) / 100

      if (this.percentV >= 0.3) {
        this.$el.classList.add('is-visible')
      } else {
        this.$el.classList.remove('is-visible')
      }
    }
  },
  mounted () {

  }
}

</script>

<style lang="stylus">
/**
 * ATTENTION - STYLES NOT SCOPED
 */

.ParagraphExergue
  position: relative
  box-sizing border-box
  max-width 800px
  font-weight 400
  padding 0 20px 0 40px
  font-size: 20px;
  line-height: 36px;

  @media $mq_m
    font-size: 22px;
    line-height: 40px;
    padding 0 40px 0 80px

  &::before
    content ''
    position: absolute
    top 50%
    transform translateY(-50%)
    right: auto
    bottom 0
    left 20px
    width 2px
    transition all 0.8s $ease
    height 100%
    background-color currentColor
    max-height 0%

    @media $mq_m
      left 40px
      width 5px

  p
    margin 0
    font-size: inherit
    line-height: inherit
    font-weight inherit
    opacity 0
    transform translateX(-20px)
    transition all 0.8s $ease

  &.is-visible

    &::before

      max-height 100%

    p

      opacity 1
      transform translateX(0px)

</style>
